export default "__VITE_ASSET__DbOrfmy8__"